// extracted by mini-css-extract-plugin
export default {"short_clip":"style_short_clip__MXQbu","skeletonLoader":"style_skeletonLoader__jeBhT","scale":"style_scale__5+Jjb"};